module.exports = __webpack_public_path__ + "img/10.305df139.jpg";